import copy from 'copy-to-clipboard'
import React, { useState } from 'react'

interface Props {
  children: (props: RenderProps) => React.ReactNode
  textToCopy: string
}

interface RenderProps {
  copyText: () => void
  justCopied: boolean
}

const CopyButton: React.FC<Props> = ({ children, textToCopy }) => {
  const [justCopied, setJustCopied] = useState(false)

  function copyText() {
    copy(textToCopy)

    setJustCopied(true)

    setTimeout(() => {
      setJustCopied(false)
    }, 2000)
  }

  return <>{children({ justCopied, copyText })}</>
}

export default CopyButton
